import React, { Component } from "react";
import Label from "./Label";

export class RadioGroup extends Component {
  render() {
    var radioButtons = [];
    for (var o in this.props.radioButtons.options) {
      var name = o;
      radioButtons.push(
        <div key={name}>
          <input
            name={name}
            type="radio"
            value={o}
            checked={this.props.radioButtons.selected_option === name}
            onChange={this.props.onChange}
          />
          &nbsp;{this.props.radioButtons.options[o].label}
        </div>
      );
    }

    return (
      <div>
        <Label name={this.props.label_name} required={this.props.required} />
        {radioButtons}
      </div>
    );
  }
}
